
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import IconCollection from '../../IconCollection/IconCollection';
import { setMinutesLog, setSecondsLog } from '../../redux/reducers/logReducer';



const LogTimer = () => {
  const dispatch = useDispatch();
   const logReducer = useSelector((state) => state?.logReducer)
  const { minutes, seconds } = logReducer

  const [editMode, setEditMode] = useState({ type: null, value: '' });

  const handleMinutesChange = (amount) => {
    const newMinutes = minutes + amount;
    if (newMinutes >= 0) {
      dispatch(setMinutesLog(newMinutes));
    }
  };

  const handleSecondsChange = (amount) => {
    let newSeconds = seconds + amount;
    let newMinutes = minutes;

    if (newSeconds >= 60) {
      newMinutes += 1;
      newSeconds -= 60;
    } else if (newSeconds < 0) {
      if (newMinutes > 0) {
        newMinutes -= 1;
        newSeconds += 60;
      } else {
        newSeconds = 0; // Prevent negative seconds when minutes are zero
      }
    }

    dispatch(setMinutesLog(newMinutes));
    dispatch(setSecondsLog(newSeconds));
  };

  const handleEdit = (type) => {
    setEditMode({ type, value: type === 'minutes' ? minutes : seconds });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) { // Ensure only digits are entered
      setEditMode({ ...editMode, value });
    }
  };

  const handleInputBlur = () => {
    const value = parseInt(editMode.value, 10);
    if (!isNaN(value) && value >= 0) {
      if (editMode.type === 'minutes') {
        dispatch(setMinutesLog(value));
      } else if (editMode.type === 'seconds') {
        dispatch(setSecondsLog(value < 60 ? value : 59));
      }
    }
    setEditMode({ type: null, value: '' });
  };

  const handleInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleInputBlur();
    }
  };

  return (
    <div className="flex justify-between items-center gap-[6.5px] lg:gap-[10px] max-w-[193px] w-full">
      <div className="flex flex-col gap-4">
        <button
          // disabled={isRunning || quarter === "Final"}
          onClick={() => handleMinutesChange(1)}
          className="flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]"

        >
          <IconCollection name="plus-icon-16" />
        </button>
        <button
          // disabled={isRunning || quarter === "Final"}
          onClick={() => handleMinutesChange(-1)}
          className="flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]"

        >
          <IconCollection name="mains-icon-16" />
        </button>
      </div>
      <div className="font-bebas text-[#1A1A1A] text-2xl lg:text-[64px] flex gap-2 items-center">
        {editMode.type === 'minutes' ? (
          <input
            type="text"
            value={editMode.value}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyPress={handleInputKeyPress}
            className="w-16 text-center"
            autoFocus
          />
        ) : (
          <span onClick={() => handleEdit('minutes')} className="cursor-pointer">
            {minutes}
          </span>
        )}
        :
        {editMode.type === 'seconds' ? (
          <input
            type="text"
            value={editMode.value}
            onChange={handleInputChange}
            onBlur={handleInputBlur}
            onKeyPress={handleInputKeyPress}
            className="w-16 text-center"
            autoFocus
          />
        ) : (
          <span onClick={() => handleEdit('seconds')} className="cursor-pointer">
            {seconds < 10 ? `0${seconds}` : seconds}
          </span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <button

          onClick={() => handleSecondsChange(1)}
          className="flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]"

        >
          <IconCollection name="plus-icon-16" />
        </button>
        <button

          onClick={() => handleSecondsChange(-1)}
          className="flex justify-center items-center w-6 h-6 border-[#CCCCCC] border-[1px] rounded bg-[#f2f2f2]"

        >
          <IconCollection name="mains-icon-16" />
        </button>
      </div>
    </div>
  );
};

export default LogTimer;
